import { useMemo, useState } from 'react';
import { categories, hotList } from '@/mocks/chigua';

type TabKey = '飙升' | '热议' | '新进';

const TABS: TabKey[] = ['飙升', '热议', '新进'];

function upValue(s: string) {
  const n = s.replace(/[^\d]/g, '');
  return Number(n) || 0;
}

export default function Sidebar() {
  const [tab, setTab] = useState<TabKey>('飙升');

  const list = useMemo(() => {
    let arr = [...hotList];
    if (tab === '飙升') arr = arr.sort((a, b) => upValue(b.up) - upValue(a.up));
    else if (tab === '热议') arr = arr.sort((a, b) => upValue(b.heat) - upValue(a.heat));
    else arr = arr.sort((a, b) => Number(b.id.replace('h', '')) - Number(a.id.replace('h', '')));
    return arr.slice(0, 10);
  }, [tab]);

  return (
    <div id="rank" className="space-y-6 lg:sticky lg:top-24">
      {/* hot rank */}
      <section className="overflow-hidden rounded-lg border border-secondary-100 bg-background-50">
        <div className="flex items-center justify-between border-b border-secondary-100 px-4 py-3 md:px-5">
          <div className="flex items-center gap-2">
            <span className="flex h-7 w-7 items-center justify-center rounded bg-primary-500 text-background-50">
              <i className="ri-fire-fill text-sm"></i>
            </span>
            <h3 className="heading-font text-base font-bold text-foreground-950">全网热榜</h3>
          </div>
          {/* tabs */}
          <div className="flex items-center gap-1 rounded-full bg-secondary-100 p-1">
            {TABS.map((t) => (
              <button
                key={t}
                type="button"
                onClick={() => setTab(t)}
                className={`whitespace-nowrap rounded-full px-3 py-1 text-xs transition-colors ${
                  tab === t ? 'bg-background-50 text-primary-600' : 'text-foreground-600 hover:text-foreground-800'
                }`}
              >
                {t}榜
              </button>
            ))}
          </div>
        </div>

        <ul className="divide-y divide-secondary-100">
          {list.map((h, i) => {
            const medal = i === 0 ? 'text-accent-500' : i === 1 ? 'text-primary-500' : i === 2 ? 'text-foreground-400' : 'text-foreground-300';
            return (
              <li key={`${tab}-${h.id}`}>
                <a href="#ts" className="group flex items-center gap-3 px-4 py-3 transition-colors hover:bg-secondary-50 md:px-5">
                  <span className={`heading-font w-5 text-center text-lg font-extrabold ${medal}`}>
                    {i + 1}
                  </span>
                  <span className="flex min-w-0 flex-1 flex-col">
                    <span className="line-clamp-1 text-sm text-foreground-800 transition-colors group-hover:text-primary-600">
                      {h.title}
                    </span>
                    <span className="mt-0.5 flex items-center gap-2 text-[10px] text-foreground-400">
                      <span>{h.cat}</span>
                      <span className="flex items-center gap-0.5 text-primary-500">
                        <i className="ri-arrow-up-line text-[10px]"></i>
                        {h.up}
                      </span>
                    </span>
                  </span>
                  <span className="whitespace-nowrap text-[10px] text-foreground-400">{h.heat}</span>
                </a>
              </li>
            );
          })}
        </ul>
      </section>

      {/* quick categories */}
      <section className="rounded-lg border border-secondary-100 bg-background-50 p-4 md:p-5">
        <h4 className="mb-3 flex items-center gap-2 text-sm font-bold text-foreground-950">
          <i className="ri-grid-fill text-primary-500"></i> 热门栏目
        </h4>
        <div className="flex flex-wrap gap-2">
          {categories.map((c) => (
            <a
              key={c.id}
              href="#lanmu"
              className="inline-flex items-center gap-1.5 rounded-full border border-secondary-200 bg-secondary-50 px-3 py-1.5 text-xs text-foreground-700 transition-colors hover:border-primary-200 hover:bg-primary-50 hover:text-primary-700 whitespace-nowrap"
            >
              <i className={`${c.icon} text-primary-500`}></i>
              {c.name}
            </a>
          ))}
        </div>
      </section>

      {/* promo */}
      <section className="relative overflow-hidden rounded-lg bg-gradient-to-br from-foreground-900 to-foreground-950 p-5 text-background-50">
        <div className="absolute -right-6 -top-6 h-24 w-24 rounded-full bg-accent-500/20 blur-2xl"></div>
        <div className="relative">
          <h4 className="heading-font text-base font-bold">想把瓜吃得更有章法？</h4>
          <p className="mt-1.5 text-xs leading-relaxed text-background-100/85">
            加入吃瓜网爆编辑部，把观察变成专题、把线索整理成深度内容。
          </p>
          <a
            href="#about"
            className="mt-3 inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-accent-500 px-3.5 py-2 text-xs font-semibold text-foreground-950 transition-colors hover:bg-accent-400"
          >
            了解平台 <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </section>
    </div>
  );
}